import React, { useEffect, useState } from 'react';

const Banner = () => {
    const [currentSlide, setCurrentSlide] = useState(0)
    const slides = [
        { heading: 'hello', image: 'https://i.ibb.co/6rPx6N9/banner1.jpg' },
        { heading: 'hello', image: 'https://i.ibb.co/w6bYz0W/outdoor1.jpg' },
        { heading: 'hello', image: 'https://i.ibb.co/CmhDtKr/banner3.jpg' }
    ];

    const nextSlide = () => {
        const next = currentSlide >= slides.length - 1 ? 0 : currentSlide + 1;
        setCurrentSlide(next);
    }

    useEffect(() => {
        const slideInterval = setInterval(nextSlide, 10000);
        return () => clearInterval(slideInterval);
    }, [currentSlide]);

    return (
        <>
            <div className='w-full min-h-screen mx-auto relative overflow-x-hidden'>
                {
                    slides.map((slide, index) =>
                        <div className={`absolute w-full h-full right-0 transform ${index > currentSlide && 'translate-x-full'} ${index < currentSlide && '-translate-x-full'} transition duration-1000`}>

                            <img className='w-full h-full object-cover' src={slide.image} alt="" />

                            <div className='absolute flex justify-center items-center transform -translate-y-1/2 left-0 right-0 top-1/2 bg-black w-full h-full bg-opacity-40'>
                                <h2 className='text-white font-bold opacity-100 great-vibes text-2xl md:text-5xl'>Welcome To The Universe of Bicycles</h2>
                            </div>
                        </div>)
                }
            </div>
        </>
    );
};

export default Banner;